import { InjectionToken } from "@angular/core";
import { AutoBonusCarTypesPort } from "./auto-bonus-car-types.port";

export const AUTO_BONUS_CAR_TYPES_PORT =
  new InjectionToken<AutoBonusCarTypesPort>("AUTO_BONUS_CAR_TYPES_PORT");
